// Trend Micro Vision One XDR datasource mappings.
// eventId stored in extra.eventId; eventSubId values stored in eventCodes[].
// Emitter builds: "eventId:X AND eventSubId:Y" or "eventId:X AND eventSubId:(Y OR Z)"
// Joined with joinDirect since the base renderer finalize() prepends " AND " to its body.
import type { DatasourceMap } from '../datasource.types'

export const trendMicroMap: DatasourceMap = {
  'Trend Micro Vision One': {
    any: {
      // eventId:1 = Endpoint Activity; subIds 2=Process Created, 5=Process Executed
      process_creation: { eventCodes: ['2', '5'], extra: { eventId: '1' } },
      // eventId:1 = Endpoint Activity; subId 4=Module Loaded
      image_load: { eventCodes: ['4'], extra: { eventId: '1' } },
      // eventId:2 = File; subIds 101=File Created, 109=File Modified
      file_event: { eventCodes: ['101', '109'], extra: { eventId: '2' } },
      // eventId:3 = Network; subIds 201=Connected, 203=DNS Queried, 204=Connection Closed
      //network_connection: { eventCodes: ['201', '203', '204'], extra: { eventId: '3' } },
      // eventId:4 = DNS; subId 301=DNS Response
      dns: { eventCodes: ['301'], extra: { eventId: '4' }, unsupportedFields: ['dns_answer'] },
      // eventId:5 = Registry; subIds 401=Registry Value Set, 402=Registry Key Created
      registry_event: { eventCodes: ['401', '402'], extra: { eventId: '5' } },
    },
  },
}
